import React, { useEffect, useState } from 'react';
import moment from 'moment';

/**
 * LastRefreshTimer Component
 * @param {Date} lastRefreshAt - The date/time of the last refresh
 */
const LastRefreshTimer = ({ lastRefreshAt }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // 1 minute
    return () => clearInterval(interval);
  }, []);

  if (!lastRefreshAt) return <span>--</span>;

  const minsAgo = Math.max(0, moment(currentTime).diff(moment(lastRefreshAt), 'minutes'));
  return <span>{minsAgo} mins ago</span>;
};

export default LastRefreshTimer;
